// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.amenities.RentalManagerUserPropertyMultiplexAmenityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create,
  RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyMultiplexAmenityCreateResponseWebDto,
  UserPropertyMultiplexAmenityDeleteResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  multiplexBuildingSessionId: string;
  text: string;
}
interface DeleteParams {
  amenityId: string;
  multiplexBuildingSessionId: string;
}

export interface RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyMultiplexAmenityCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Args
>;

/**
 * Create a free text property amenity on every unit in a multiplex building session
 * @deprecated
 */
export const useRentalManagerUserPropertyMultiplexAmenityWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Options = UseMutationOptions<
  UserPropertyMultiplexAmenityDeleteResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Args
>;

/**
 * Delete a free text property amenity from every unit in a multiplex building session
 * @deprecated
 */
export const useRentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete(args.getParams, httpClient),
  });
};
